import styled, { css } from 'styled-components';
import { getSpacingToken, getToken } from '@optimus-web/common';
import { Button } from '../Button';
import { DropDownButton } from '../DropDownButton';
import { SplitButtonVariant } from './types';

export const SplitButtonWrapper = styled.div<{ variant?: SplitButtonVariant }>`
    display: flex;
    gap: ${(props) => (props.variant === 'primary' ? 1 : 0)}px;
`;

export const SplitButtonContainer = styled(Button)`
    border-top-right-radius: ${getToken('borderRadius0')}px;
    border-bottom-right-radius: ${getToken('borderRadius0')}px;

    ${(props) =>
        props.variant !== 'primary' &&
        css`
            margin-right: -${getToken('borderWidth150')}px;
            &:hover {
                z-index: 1;
            }
        `}
`;

export const SplitButtonDropdown = styled(DropDownButton)`
    ${':is(button)'} {
        border-top-left-radius: ${getToken('borderRadius0')}px;
        border-bottom-left-radius: ${getToken('borderRadius0')}px;
        padding-left: ${getSpacingToken('0')};
        padding-right: ${getSpacingToken('100')}px;
    }
`;
